import { getPostHog } from "@/lib/posthog";

// Toggle this to enable/disable tracking in development
const TRACK_IN_DEVELOPMENT = false;

/**
 * Wrapper function to conditionally track events based on environment
 */
function trackEvent(eventName: string, properties?: Record<string, unknown>) {
	try {
		// Skip tracking in development unless explicitly enabled
		if (process.env.NODE_ENV === "development" && !TRACK_IN_DEVELOPMENT) {
			console.log(`[DEV] Would track event: ${eventName}`, properties);
			return;
		}

		void getPostHog().then((posthog) => posthog.capture(eventName, properties));
	} catch (error) {
		console.error(`Error tracking event: ${eventName}`, error);
	}
}

/**
 * Wrapper function to conditionally identify users based on environment
 */
function identifyUserInPostHog(
	distinctId: string,
	properties?: Record<string, unknown>,
) {
	// Skip tracking in development unless explicitly enabled
	if (process.env.NODE_ENV === "development" && !TRACK_IN_DEVELOPMENT) {
		return;
	}

	void getPostHog().then((posthog) => posthog.identify(distinctId, properties));
}

/**
 * Identify user in PostHog (call when user data is available)
 */
export function identifyUser({
	email,
	name,
}: {
	email: string;
	name?: string;
}) {
	identifyUserInPostHog(email, {
		email,
		...(name && { name }),
	});
}

/**
 * Track user sign-up
 */
function trackSignUp() {
	trackEvent("user_signed_up");
}

/**
 * Track onboarding product creation
 */
function trackOnboardingProductCreation({
	productType,
}: {
	productType: "free" | "paid";
}) {
	trackEvent("onboarding_product_created", {
		product_type: productType,
	});
}

/**
 * Track onboarding feature creation
 */
function trackOnboardingFeatureCreation({
	featureType,
}: {
	featureType: string;
}) {
	trackEvent("onboarding_feature_created", {
		feature_type: featureType,
	});
}

/**
 * Track onboarding feature configuration
 */
function trackOnboardingFeatureConfigured() {
	trackEvent("onboarding_feature_configured");
}

/**
 * Track onboarding playground completion
 */
function trackOnboardingPlaygroundCompleted() {
	trackEvent("onboarding_playground_completed");
}

/**
 * Track onboarding integration completion
 */
function trackOnboardingIntegrationCompleted() {
	trackEvent("onboarding_integration_completed");
}
